<p-dialog header="{{ 'UPGRADE_PRO_FEATURES' | translate }}" [(visible)]="visible" (onHide)="onDialogHide()"
    [breakpoints]="{'800px': '90vw'}" [style]="{width: '50vw'}" [modal]="true">
    <section>
        <div class="plan-container">
            <div class="text-center mb-4">
                <h2 class="mb-4 text-3xl tracking-tight font-extrabold text-gray-900 dark:text-white">{{
                    'DESIGNED_PROFESSIONALS' | translate }}</h2>
                <p class="font-light text-gray-500 sm:text-xl dark:text-gray-400 mb-3">{{ 'EXPERIENCE_ANALYSIS' |
                    translate }}</p>
                <img src="assets/images/screenshots/pro-data1.png" alt="screenshot" width="100%">
                <p class="font-light text-gray-500 sm:text-xl dark:text-gray-400 mb-3 mt-5">{{ 'GAIN_INSIGHTS' |
                    translate }}</p>
                <img src="assets/images/screenshots/pro-data2.png" alt="screenshot" width="100%">
                <img src="assets/images/screenshots/pro-data3.png" alt="screenshot" width="100%">
                <p class="font-light text-gray-500 sm:text-xl dark:text-gray-400 mb-4 mt-5">{{ 'VISUALIZE_EXPORT' |
                    translate }}</p>
                <img src="assets/images/screenshots/pro-data4.png" alt="screenshot" width="100%">
                <p class="font-light text-gray-500 sm:text-xl dark:text-gray-400 mb-3 mt-5">{{ 'ADVANTAGE_PRO_PLAN' |
                    translate }}</p>
            </div>
            <div class="d-flex justify-content-center">
                <div class="plan">
                    <h3 class="plan__title">{{ 'PRO_FEATURES' | translate }}</h3>
                    <p class="font-light text-gray-500 sm:text-lg dark:text-gray-400 px-5">{{ 'BEST_OPTION' | translate
                        }}</p>
                    <div class="plan__price">
                        <span class="mr-2 text-5xl font-extrabold">$99</span>
                        <span class="text-gray-500 dark:text-gray-400">/month</span>
                    </div>
                    <div class="plan__benefits">
                        <div class="plan__benefit">
                            <i class="pi pi-check" style="color: green"></i>
                            <span>{{ 'VIEW_PRESSURES' | translate }}</span>
                        </div>
                        <div class="plan__benefit">
                            <i class="pi pi-check" style="color: green"></i>
                            <span>{{ 'ACCESS_METRICS' | translate }}</span>
                        </div>
                        <div class="plan__benefit">
                            <i class="pi pi-check" style="color: green"></i>
                            <span>{{ 'VISUALIZE_GRAPHS' | translate }}</span>
                        </div>
                        <div class="plan__benefit">
                            <i class="pi pi-check" style="color: green"></i>
                            <span>{{ 'EXPORT_PDF' | translate }}</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <button mat-raised-button style="margin-bottom: 10px;"
                            class="btn plan__button btn-rounded btn-block" (click)="buySubscriptionNow()">
                            <ng-container *ngIf="!loadingSubscription; else loading">
                                {{ 'GET_STARTED' | translate }}
                            </ng-container>
                            <ng-template #loading>
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
                                </div>
                            </ng-template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</p-dialog>